import { render, staticRenderFns } from "./CandidateDocumentPage.vue?vue&type=template&id=61431e84&scoped=true&"
import script from "./CandidateDocumentPage.vue?vue&type=script&lang=js&"
export * from "./CandidateDocumentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61431e84",
  null
  
)

export default component.exports